/* Stylesheet */

.stats_slide {
  padding: 0;
  height: 100%;

  .row {
    padding: 0;

    .col {
      padding: 0;
      display: flex;
      align-items: center;
    }

    .key_col {
      margin: 0px 0px 0px 52px;

      .key {
        color: var(--ion-color-text-primary);
      }
    }

    .value_col {
      margin: 0px 52px 0px 0px;
      justify-content: flex-end;

      .value {
        display: flex;
        height: 52px;
        width: 52px;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
        border-radius: 32px;
        box-shadow: var(--ion-box-shadow);
        transition: 0.75s ease-out;
      }
    }
  }
}
